import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Table, Input, InputNumber, Popconfirm, Button } from 'antd'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import numeral from 'numeral'
import Loader from '../../common/Loader'
import { actions as partActions } from '../../../redux/modules/jobFunctions/jobPartActions'
import { actions as itemActions } from '../../../redux/modules/jobFunctions/itemActions'
import styled from 'styled-components'
import { convertToOption } from '../../../util'
import config from '../../../config'

const { Column } = Table

const AddItemArea = styled.div`
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
`
const { API_BASE } = config

const propTypes = {}

const EditableCell = ({ editable, value, onChange }) => (
  <div>
    {editable ? (
      <Input style={{ margin: '-5px 0' }} value={value} onChange={e => onChange(e.target.value)} />
    ) : (
      value
    )}
  </div>
)

class JobParts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      partsItems: [],
      addItemInput: '',
      addDescriptionInput: '',
      addItemName: '',
      addCostInput: 0,
      isLoading: false,
      options: convertToOption(
        this.props.itemActions.allItems ? this.props.itemActions.allItems.data : []
      )
    }
  }

  componentWillMount() {
    this.props.getJobParts({
      jobId: this.props.jobId
    })
    this.props.getAllItems()
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.jobPartActions.jobParts !== nextProps.jobPartActions.jobParts) {
      this.setState({
        partsItems: nextProps.jobPartActions.jobParts.data
      })
    }
  }

  editRow = rowId => {
    const groupedItems = this.state.partsItems.map(row => {
      if (row.id === rowId) row.isEditingRow = true
      return row
    })
    this.setState({
      partsItems: groupedItems
    })
  }

  saveRow = rowId => {
    const groupedItems = this.state.partsItems.map(row => {
      if (row.id === rowId) {
        row.isEditingRow = false
        this.props.updateJobPart({
          jobId: this.props.jobId,
          partId: row.id,
          content: {
            itemId: row.itemId,
            name: row.name,
            cost: row.cost,
            description: row.description
          },
          userId: this.props.user.userId
        })
      }
      return row
    })

    this.setState({
      partsItems: groupedItems
    })
  }

  deleteRow = rowId => {
    this.props.deleteJobPart({
      jobId: this.props.jobId,
      partId: rowId
    })
  }

  handleAddItemInputSelect = value => {
    if (value.length > 0) {
      let selectedId = value[0].value
      const selectedItem = this.props.itemActions.allItems.data.filter(
        row => parseInt(row.id, 0) === selectedId
      )
      if (selectedItem.length > 0) {
        this.setState({
          addItemInput: selectedId,
          addItemName: selectedItem[0].name,
          addDescriptionInput: selectedItem[0].description,
          addCostInput: selectedItem[0].cost
        })
      }
    }
  }

  handleAddDescriptionInputChange = value => {
    this.setState({
      addDescriptionInput: value
    })
  }

  handleAddCostInputChange = value => {
    this.setState({
      addCostInput: value
    })
  }

  handleAddItemClick = () => {
    this.props.addJobPart({
      jobId: this.props.jobId,
      content: {
        itemId: this.state.addItemInput,
        name: this.state.addItemName,
        cost: this.state.addCostInput,
        description: this.state.addDescriptionInput
      },
      userId: this.props.user.userId
    })
    this.setState({
      addItemInput: '',
      addItemName: '',
      addDescriptionInput: '',
      addCostInput: 0
    })
    this.refs.typeahead.getInstance().clear()
  }

  _handleSearch = query => {
    this.setState({ isLoading: true })

    const searchOnItems = async query => {
      const items = convertToOption(
        this.props.itemActions.allItems ? this.props.itemActions.allItems.data : []
      )
      const foundItems = items.filter(
        item => item.text.toLowerCase().indexOf(query.toLowerCase()) !== -1
      )
      return foundItems
    }

    searchOnItems(query).then(options => {
      this.setState({
        isLoading: false,
        options
      })
    })
  }

  handleInputChange = (value, key, column) => {
    const groupedItems = this.state.partsItems.map(row => {
      if (row.id === key) row[column] = value
      return row
    })
    this.setState({
      partsItems: groupedItems
    })
  }

  renderColumns(text, record, column) {
    return (
      <EditableCell
        editable={record.isEditingRow}
        value={text}
        onChange={value => this.handleInputChange(value, record.id, column)}
      />
    )
  }

  handlePrint = () => {
    const { jobId } = this.props
    window.open(`${API_BASE}/api/job/parts/${jobId}/print`, '_blank')
  }

  render() {
    if (!this.props.jobPartActions.jobParts) {
      return <Loader />
    }
    const itemsData = this.props.itemActions.allItems ? this.props.itemActions.allItems.data : []

    return (
      <div>
        <div className="jobsBar">
          Items
          <div className="d-flex">
            <div className="jobsBarAdd">
              <i className="fa fa-print" aria-hidden="true" />
              &nbsp;
              <div onClick={() => this.handlePrint()} className="addJobLabel">
                PRINT
              </div>
            </div>
          </div>
        </div>
        {this.props.jobPartActions.jobParts && (
          <div>
            <Table
              dataSource={this.state.partsItems}
              size="small"
              bordered
              pagination={false}
              rowKey="id"
            >
              <Column
                title="Name"
                dataIndex="name"
                key="name"
                width={250}
                render={(text, record) => this.renderColumns(text, record, 'name')}
              />
              <Column
                title="Description"
                dataIndex="description"
                key="description"
                render={(text, record) => this.renderColumns(text, record, 'description')}
              />
              <Column
                title="Cost"
                dataIndex="cost"
                key="cost"
                render={(text, record) =>
                  this.renderColumns(numeral(text).format('$0,0.00'), record, 'cost')
                }
              />
              <Column
                title=" "
                dataIndex="action"
                key="action"
                render={(text, record) => {
                  return (
                    <div>
                      {record.isEditingRow && (
                        <Button icon="save" onClick={() => this.saveRow(record.id)} />
                      )}
                      {!record.isEditingRow && (
                        <Button icon="edit" onClick={() => this.editRow(record.id)} />
                      )}
                      <Popconfirm
                        title="Are you sure you want to delete this line?"
                        onConfirm={() => this.deleteRow(record.id)}
                        onCancel={this.cancelDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button className="marginLeft5" type="danger" icon="delete" />
                      </Popconfirm>
                    </div>
                  )
                }}
                width={90}
              />
            </Table>
            <AddItemArea>
              <div className="row">
                <div className="col-md-4">
                  <AsyncTypeahead
                    ref="typeahead"
                    id="typeAheadInput"
                    delay={200}
                    labelKey="text"
                    isLoading={this.state.isLoading}
                    options={convertToOption(itemsData)}
                    minLength={1}
                    onSearch={this._handleSearch}
                    placeholder="Search for some Item..."
                    onChange={selected => {
                      this.handleAddItemInputSelect(selected)
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    placeholder="Part description..."
                    value={this.state.addDescriptionInput}
                    onChange={event => this.handleAddDescriptionInputChange(event.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <InputNumber
                    onChange={event => {
                      this.handleAddCostInputChange(event)
                    }}
                    value={this.state.addCostInput}
                    formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                  />
                </div>
                <div className="col-md-3 text-right">
                  <Button onClick={() => this.handleAddItemClick()}>Add Item</Button>
                </div>
              </div>
            </AddItemArea>
            <br />
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobPartActions, itemActions }, ownProps) => ({
  jobPartActions,
  itemActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, partActions, itemActions), dispatch)
})

JobParts.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobParts))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobParts.js